import { useState } from "react";
import axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import "./Unsubscribe.css";
import "../RegPulseLinkExpire/RegPulseLinkExpire.css";
import "../Home/Components/HomeBanner.css";

const Unsubscribe = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = params.token || searchParams.get("token") || "";
  const [isUnsubscribing, setIsUnsubscribing] = useState(false);
  const [message, setMessage] = useState("");

  const handleUnsubscribe = async () => {
    if (!token) {
      setMessage("Invalid unsubscribe link. Token is missing.");
      return;
    }

    try {
      setIsUnsubscribing(true);
      setMessage("");
      const response = await axios.post(`${API_BASE_URL}/unsubscribePlans`, null, {
        params: { token },
      });

      if (String(response.data?.code) === "200" && response.data?.status === "SUCCESS") {
        const feedbackToken = response.data?.message?.label2;

        if (typeof feedbackToken === "string" && feedbackToken) {
          navigate(`/regpulsefeedback?token=${encodeURIComponent(feedbackToken)}`);
          return;
        }
      }

      navigate("/regpulseunsubscribeerror");
      return;
    } catch (error) {
      console.error("Error unsubscribing from RegPulse:", error);
      navigate("/regpulseunsubscribeerror");
    } finally {
      setIsUnsubscribing(false);
    }
  };

  return (
    <section className="regpulse-expire-page">
      <div className="regpulse-expire-content">
        <p className="regpulse-expire-eyebrow">EvoNext RegPulse</p>
        <h1>Unsubscribe from RegPulse</h1>
        <p className="regpulse-expire-message">
          Click below to stop receiving RegPulse email updates.
        </p>
        <button
          type="button"
          className="regpulse-expire-button getintouchbtn"
          onClick={handleUnsubscribe}
          disabled={isUnsubscribing}
        >
          {isUnsubscribing ? "Unsubscribing..." : "Unsubscribe"}
        </button>
        {message && <p className="unsubscribe-error" role="alert">{message}</p>}
        {/* <Link to="/home">Back to www.evonext.ai</Link> */}
      </div>
    </section>
  );
};

export default Unsubscribe;
